<div class="igntr-theme">
  <div
    class="rounded-2xl overflow-hidden"
    [ngClass]="viewMode === 'list' ? 'border !border-slate-200/70' : ''"
    [ngStyle]="viewMode === 'list' ? { background: 'white' } : {}"
  >
    <div
      class="hidden md:flex items-center gap-4 px-4 py-2.5 text-[14px] font-semibold tracking-[0.08em] !text-slate-500 border-b !border-slate-200/70 !bg-slate-50/60"
      *ngIf="viewMode === 'list'"
    >
      <button
        class="flex-1 text-left inline-flex items-center gap-1 hover:!text-slate-900 ml-12"
        (click)="onSort('name')"
      >
        {{ "name" | transloco }}
        <span
          class="text-[14px]"
          [ngClass]="sortField === 'name' ? 'text-slate-700' : 'text-slate-300'"
        >
          {{ sortField === "name" && sortDirection === "asc" ? "▲" : "▼" }}
        </span>
      </button>
      <button
        class="w-40 text-left inline-flex items-center gap-1 hover:!text-slate-900"
        (click)="onSort('created')"
      >
        {{ "created" | transloco }}
        <span
          class="text-[14px]"
          [ngClass]="
            sortField === 'created' ? 'text-slate-700' : 'text-slate-300'
          "
        >
          {{ sortField === "created" && sortDirection === "asc" ? "▲" : "▼" }}
        </span>
      </button>
      <div class="w-24"></div>
    </div>

    <div
      [ngClass]="
        viewMode === 'list'
          ? ''
          : 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3'
      "
    >
      <div
        *ngFor="let tenant of initTenants"
        [ngClass]="
          viewMode === 'list'
            ? 'group relative flex items-center justify-between px-3 py-2 cursor-pointer border-b !border-slate-100 last:border-b-0 hover:bg-[oklch(0.985_0.008_47)]'
            : 'group text-left bg-white border !border-slate-200 rounded-2xl p-3 hover:!border-slate-300 hover:shadow-[0_4px_20px_-8px_rgba(0,0,0,.1)] '
        "
        [routerLink]="['/tenants', tenant.id]"
      >
        <div class="flex flex-1 gap-3 w-[36px]">
          <div
            class="shrink-0 w-9 h-9 rounded-lg flex items-center justify-center text-[14px] font-semibold !text-slate-700 border !border-slate-200/70 w-[36px]"
            style="background: oklch(0.96 0.02 125)"
          >
            {{ getInitials(tenant.name) }}
          </div>
          <div
            class="lg:min-w-[175px]"
            [ngClass]="viewMode === 'list' ? 'min-w-0 ' : ''"
          >
            <div class="flex items-center gap-2 min-w-0 shrink-0">
              <div class="text-[14px] font-medium !text-slate-900 truncate">
                {{ tenant.name }}
              </div>
              <!-- <span
                *ngIf="viewMode === 'list'"
                class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] border bg-[oklch(0.96_0.02_47)] text-[oklch(0.42_0.15_47)] border-[oklch(0.88_0.06_47)]"
              >
                {{ "enterprise" | transloco }}
              </span> -->
              <igntr-icon
                name="pin"
                strokeColor="oklch(0.67 0.17 47)"
                *ngIf="tenant.pinned"
              ></igntr-icon>
            </div>
            <div
              class="flex items-center gap-3 mt-0.5 text-[12px] !text-slate-500 min-w-0 shrink-0 tra"
            >
              <!-- <span class="inline-flex items-center gap-1">
                <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"> </span>
                {{ "active" | transloco }}
              </span> -->
              <!-- <span
                *ngIf="viewMode === 'grid'"
                class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] border bg-[oklch(0.96_0.02_47)] text-[oklch(0.42_0.15_47)] border-[oklch(0.88_0.06_47)]"
              >
                {{ "enterprise" | transloco }}
              </span> -->
              <span
                *ngIf="viewMode === 'list'"
                class="font-mono tabular-nums truncate md:w-auto md:max-w-fit md:overflow-visible md:text-clip md:whitespace-normal"
                >{{ formatText(tenant.name) }}</span
              >
            </div>
          </div>
        </div>
        <div
          [ngClass]="
            viewMode === 'list'
              ? 'w-24 shrink-0 hidden lg:block'
              : 'mt-3 flex items-center justify-between'
          "
        >
          <span
            class="inline-flex items-center gap-1 text-[12px] !text-slate-500"
          >
            <igntr-icon name="users"></igntr-icon>
            <span class="font-mono tabular-nums"
              >{{ tenant.countOfUsers }}
            </span>
          </span>
        </div>
        <div
          class="mt-3 pt-3 border-t !border-slate-100 flex items-center justify-between"
          *ngIf="viewMode === 'card'"
        >
          <span class="font-mono text-[12px] !text-slate-400 tabular-nums">
            {{ tenant.createdAt | date: "dd-MM-yyyy" }}
          </span>
          <span
            class="text-[14px] !text-slate-400 group-hover:!text-slate-700 transition-colors inline-flex items-center gap-1"
          >
            {{ "open" | transloco }}
            <igntr-icon name="chevronR"></igntr-icon>
          </span>
        </div>
        <div class="w-40 shrink-0 hidden md:block" *ngIf="viewMode === 'list'">
          <div class="font-mono text-[12px] !text-slate-500 tabular-nums">
            {{ tenant.createdAt | date: "dd-MM-yyyy HH:mm" }}
          </div>
        </div>
        <div
          *ngIf="viewMode === 'list'"
          class="shrink-0 items-center gap-1 opacity-100 lg:opacity-0 group-hover:opacity-100 transition-opacity inline-flex"
        >
          <button
            title="Pin"
            class="p-1.5 rounded-md hover:bg-slate-100 !text-slate-500 hover:!text-slate-800 hidden md:inline-flex"
            (click)="$event.stopPropagation(); onPin(tenant)"
          >
            <igntr-icon name="pin"></igntr-icon>
          </button>

          <!-- <button
            title="Impersonate"
            class="p-1.5 rounded-md hover:bg-slate-100 !text-slate-500 hover:!text-slate-800 inline-flex"
          >
            <igntr-icon name="impersonate"></igntr-icon>
          </button> -->
          <button
            title="Clone"
            class="p-1.5 rounded-md hover:bg-slate-100 !text-slate-500 hover:!text-slate-800 inline-flex"
            (click)="cloneConfirmation = tenant; $event.stopPropagation()"
            data-bs-target="#cloneusermodal"
          >
            <igntr-icon name="copy"></igntr-icon>
          </button>
          <button
            title="More"
            class="p-1.5 rounded-md hover:bg-slate-100 !text-slate-500 hover:!text-slate-800 inline-flex"
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
          >
            <igntr-icon name="dots"></igntr-icon>
          </button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item [routerLink]="['/tenants', tenant.id]">
              {{ "edit" | transloco }}
            </button>

            <button mat-menu-item [routerLink]="['/deleting', tenant.id]">
              {{ "delete" | transloco }}
            </button>
          </mat-menu>
          <div class="hidden md:inline-flex">
            <igntr-icon name="chevronR"></igntr-icon>
          </div>
        </div>
      </div>
      <div class="py-16 text-center" *ngIf="initTenants.length === 0">
        <div class="text-[14px] text-slate-500">
          {{ "noTenants" | transloco }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <p-table
  #dt1
  [value]="initTenants"
  [globalFilterFields]="['name', 'createdAt']"
>
  <ng-template pTemplate="header">
    <tr>
      <th [attr.colspan]="innerWidth < 1200 ? 3 : 2">
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-search"></i>
          </p-inputgroup-addon>
          <input
            type="text"
            pInputText
            (input)="onGlobalFilter(dt1, $event)"
            placeholder="{{ 'search' | transloco }}"
          />
        </p-inputgroup>
      </th>
      <th class="d-none d-xl-table-cell"></th>
    </tr>
    <tr>
      <th pSortableColumn="name" class="col-6">
        {{ "name" | transloco }} <p-sortIcon field="name"></p-sortIcon>
      </th>
      <th pSortableColumn="createdAt" class="col-5">
        {{ "created" | transloco }} <p-sortIcon field="createdAt"></p-sortIcon>
      </th>
      <th class="col-1"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-tenant>
    <tr>
      <td>
        <div class="d-flex align-items-center">
          <app-entity-avatar
            [img]=""
            [alt]="tenant.name"
            icon="bi-building"
          ></app-entity-avatar>
          <p>
            <span
              class="txt-name text-break ms-1"
              [routerLink]="['/tenants', tenant.id]"
              >{{ tenant.name }}</span
            >
            <br />
            <small>
              <span class="txt-sub text-break ms-1">
                {tenant.countOfUsers, plural,
                  =1 {1 user}
                  other {{{tenant.countOfUsers}} users}
                }</span
              >
            </small>
          </p>
        </div>
      </td>
      <td>{{ tenant.createdAt | date: "dd-MM-yyyy hh:mm" }}</td>

      <td>
        <div
          *ngIf="auth.isAnyAdmin$ | async"
          class="d-flex justify-content-end"
        >
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            tabindex="-1"
            class="small-icon-button d-flex justify-content-center align-items-center p-0"
            style="width: 32px; height: 32px; font-size: 20px; line-height: 1"
          >
            <img src="assets/img/dots-vertical.svg" alt="Menu Icon" />
          </button>

          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item [routerLink]="['/tenants', tenant.id]">
              {{ "edit" | transloco }}
            </button>

            <button mat-menu-item [routerLink]="['/deleting', tenant.id]">
              {{ "delete" | transloco }}
            </button>

            <button
              mat-menu-item
              (click)="cloneConfirmation = tenant"
              data-bs-target="#cloneusermodal"
            >
              {{ "clone" | transloco }}
            </button>

          </mat-menu>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table> -->

<app-confirm-delete
  id="deleteusermodal"
  *ngIf="deleteConfirmation"
  [deleteCandidate]="deleteConfirmation.name"
  (confirm)="handleDeleteClick(deleteConfirmation); deleteConfirmation = null"
  (cancel)="deleteConfirmation = null"
></app-confirm-delete>

<app-clone-pop-up
  id="cloneusermodal"
  *ngIf="cloneConfirmation"
  [cloneCandidateId]="cloneConfirmation.id"
  [cloneCandidateName]="cloneConfirmation.name"
  [withUsergroups]="false"
  [hideTenantOptionsSelector]="true"
  (confirm)="clone.emit($event); cloneConfirmation = null"
  (cancel)="cloneConfirmation = null"
></app-clone-pop-up>
